
let tes = [
	{
		img: require('./Rishi.jpeg'),
		name: 'Rishi Mondal',
		skill: 'Full Stack Developer',
        bio:"I'm a Software Engineer and Web Developer, skilled in coding and design. With a foundation in robust software, I'm exploring the exciting realm of machine learning, blending creativity with algorithms.",
        giturl:'https://github.com/MAVRICK-1',
        ldkurl:'https://www.linkedin.com/in/rishi-mondal-5238b2282/'
	},
	{
		img: require('./Debanjan.jpeg'),
		name: 'Aritra Sarkar',
		skill: 'Front End Developer',
        giturl:'https://github.com/RickDeb2004',
        ldkurl:'https://www.linkedin.com/in/debanjan-mukherjee-181615224/',
        bio:"Enrolled in 4-year B.TECH Industrial Design at NIT Rourkela. Skilled in AI, C++, backend dev. Passionate about distributed systems, open-source, and tech exploration."
	},
	{
		img: require('./Animesh.jpeg'),
		name: 'Saheli Saha',
		skill: 'Front End Developer',
        giturl:'https://github.com/Animesh239',
        ldkutl:'https://www.linkedin.com/in/animesh239/',
        bio : "Experienced frontend developer proficient in HTML, CSS, JavaScript, React, and Vue.js. Passionate about creating intuitive user interfaces and optimizing web performance. Dedicated to continuous learning and innovation."
	},
	{
		img: require('./Rohit.jpeg'),
		name: 'Priyanka Biswas',
		skill: 'DeveLoper',
        giturl:'https://github.com/RohitGupta1332',
        ldkurl:'https://www.linkedin.com/in/rohit-gupta-4148b6273/',
        bio:"A BCA student at Techno India Hooghly. Skilled in HTML, CSS, JavaScript, SQL, Java, Spring Boot, Hibernate. Passionate about learning new technologies. Enjoys programming tutorials, web series, and movies."
	}
]

export {tes}